import script from "./provinceContent.vue?vue&type=script&setup=true&lang=js"
export * from "./provinceContent.vue?vue&type=script&setup=true&lang=js"

import "./provinceContent.vue?vue&type=style&index=0&id=f5b05aa4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5b05aa4"]])

export default __exports__